import * as React from 'react';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import * as L from 'leaflet';
import i18next from 'i18next';
import {Map, TileLayer} from "react-leaflet";
import {mapBounds, mapOptions, maxZoom, minZoom, osmURL} from "components/Map/MapHelpers/MapHelpers";
import ZoomManagement from "components/Map/MapHelpers/ZoomManagement";
import * as MapModule from "Modules/MapModule";
import * as AlertModule from "Modules/AlertModule";
import {InfinityReactTable, InfinityScrollParams} from "components/common/InfinityReactTable";
import {Cell} from "HelperFunctions/Lists";
import {SummaryAlertsRender} from "components/Map/CarDetails/Composites/Alerts";

type Props = {
    match?: any;
};

type ConnectedDispatch = {
    setActiveHistoryAlert: (alert: AlertModule.Types.AlertHistoryLogDto) => void;
    setSmallMapCenter: (center: MapModule.Types.MapCenter) => void;
    setSmallMapZoom: Function;
};

type ConnectedProps = {
    mapStore: MapModule.Types.MapStore;
    alertStore: AlertModule.Types.AlertStore;
    t?: i18next.TFunction;
};

type State = {
    refEnabled: boolean;
};

class AlertHistory extends React.Component<Props & ConnectedProps & ConnectedDispatch, State> {
    private mapRef: L.Map;
    private componentMapRef: any;
    private infinityScrollParams: InfinityScrollParams;

    constructor(props: Props & ConnectedProps & ConnectedDispatch) {
        super(props);
        this.state = {
            refEnabled: false
        };
        this.handleRef = this.handleRef.bind(this);
        // this.handleRowclick = this.handleRowclick.bind(this);

        this.infinityScrollParams = new InfinityScrollParams();
        this.infinityScrollParams.setWaypointRef(React.createRef());
    }

    // public async componentDidMount() {
    // }

    private handleRef(ref: any) {
        if (ref) {
            this.componentMapRef = ref;
            this.mapRef = ref.leafletElement;
        }
    }

    // private handleRowclick(dataframe: VehiclesModule.Types.CarDataframeDto) {
    // }

    public render() {
        const {mapStore, t} = this.props;
        const {alertHistoryLog} = this.props.alertStore;
        const latestAlerts = alertHistoryLog !== null ? alertHistoryLog.results : null;

        return (
            <div className="main main__content main__content--no-padding">
                <div className="main__inner-left"
                     ref={this.infinityScrollParams.getWaypointRef()}>
                    <h3 className="report__title">
                        {t('alertHistory')}
                    </h3>

                    <div className="table__content">
                        {latestAlerts && <InfinityReactTable
                            // addClass={`reactTable vehicleList--table vehicleList--nomaxheight`}
                            data={latestAlerts}
                            columns={this.renderColumns(t)}
                            getTrProps={this.getTrProps}
                            onFetchData={(state, instance) => {
                                console.log('bez paginacji na razie, ale z opcją na przyszłość');
                            }}
                            waypointRef={this.infinityScrollParams.getWaypointRef()}
                        />}
                    </div>

                </div>

                <div className="main__inner-right clear-padding">
                    <Map
                        center={mapStore.smallMap.center}
                        zoom={mapStore.smallMap.zoom}
                        options={mapOptions}
                        maxZoom={maxZoom}
                        minZoom={minZoom}
                        zoomControl={false}
                        maxBounds={mapBounds}
                    >
                        <TileLayer url={osmURL}/>
                        {alertHistoryLog && <SummaryAlertsRender alertHistoryLog={alertHistoryLog}/>}
                    </Map>
                    <div className="map-manage">
                      <ZoomManagement small/>
                    </div>
                </div>
            </div>
        );
    }

    private renderColumns(t) {
        return [
            {
                Header: 'hiddenHeader',
                accessor: 'title',
                Filter: ({filter, onChange}) => <div className="filter__title">{t('title')}</div>
            },
            {
                Header: 'hiddenHeader',
                id: 'deviceId',
                accessor: 'message',
                Cell: Cell.CutTextCell
            },
            {
                Header: 'hiddenHeader',
                accessor: 'invokeDate'
            },
            {
                Header: 'hiddenHeader',
                accessor: 'priority'
            }
        ];
    }

    private getTrProps = (state: any, rowInfo: any) => {
        const {activeHistoryAlert} = this.props.alertStore;
        let className = '';
        if (rowInfo && rowInfo.original && activeHistoryAlert) {
            className = rowInfo.original.id === activeHistoryAlert.id ? 'active' : '';
        }
        return {
            className,
            onClick: () => {
                this.props.setActiveHistoryAlert(rowInfo.original);
                this.props.setSmallMapZoom(15);
                this.props.setSmallMapCenter({
                    lat: rowInfo.original.carDataframe.latitude,
                    lng: rowInfo.original.carDataframe.longitude
                });
            }
        };
    };
}

function mapStateToProps(state: ConnectedProps): ConnectedProps {
    return {
        mapStore: state.mapStore,
        alertStore: state.alertStore
    };
}

function mapDispatchToProps(dispatch: any): ConnectedDispatch {
    return {
        setActiveHistoryAlert: (alert: AlertModule.Types.AlertHistoryLogDto) => dispatch(AlertModule.Actions.setActiveHistoryAlert(alert)),
        setSmallMapCenter: (center: MapModule.Types.MapCenter) => dispatch(MapModule.Actions.smallMapsetMapCenter(center)),
        setSmallMapZoom: (zoom: number) => dispatch(MapModule.Actions.smallMapsetMapZoom(zoom))
    };
}

export default withTranslation('carDetails')(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(AlertHistory) as React.ComponentClass<any>
)



// WEBPACK FOOTER //
// ./src/components/Alerts/AlertHistory.tsx